// new Swiper(".our-banner-slider", {
//   // loop: true,
//   autoplay: {
//     delay: 2500,
//     disableOnInteraction: false 
//   },
//   // effect: 'fade',
//   speed: 800,
//   grabCursor: true, 
//   allowTouchMove: true, 
// });

const swiper = new Swiper(".our-banner-slider", {
  // loop: true,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false
  },
  speed: 800,
  grabCursor: true,
  allowTouchMove: true,
});


// 👉 Overlay-gradient swipe support
let startX = 0;
let isDown = false;
let startXMouse = 0;

const overlay = document.querySelector('.our-banner-slider .overlay-gradient');

// 📱 Mobile touch
overlay.addEventListener('touchstart', (e) => {
  startX = e.touches[0].clientX;
});

overlay.addEventListener('touchend', (e) => {
  let endX = e.changedTouches[0].clientX;

  if (startX - endX > 50) {
    swiper.slideNext();
  } else if (endX - startX > 50) {
    swiper.slidePrev();
  }
});


// 🖱 Desktop drag
overlay.addEventListener('mousedown', (e) => {
  isDown = true;
  startXMouse = e.clientX;
});

overlay.addEventListener('mouseup', (e) => {
  if (!isDown) return;
  isDown = false;

  let endX = e.clientX;

  if (startXMouse - endX > 50) {
    swiper.slideNext();
  } else if (endX - startXMouse > 50) {
    swiper.slidePrev();
  }
});

overlay.addEventListener('mouseleave', () => {
  isDown = false;
});